export default __webpack_public_path__ + "static/media/02_photo.828c8446.jpg";